import {Component, ElementRef, OnDestroy, ViewChild, inject} from '@angular/core';
import {HelperService} from '../../shared/helper.service';
import {CoreService} from '../core.service';
import {AuthService} from '../../auth/auth.service';
import { NavigationEnd, Router, RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';
import { Location, AsyncPipe } from '@angular/common';
import { EventsService } from '../../realguest/services/events.service';
import {ToolbarMenuHostDirective} from '../classes/toolbar-menu-host.directive';
import {combineLatestWith, distinctUntilChanged, filter, ReplaySubject, tap} from 'rxjs';
import {GlobalLoaderService} from '../../shared/global-loader.service';
import {BaseRxjsComponent} from '../../shared/components/BaseRxjsComponent';
import {environment} from '../../../environments/environment';
import { MatSidenavContainer, MatSidenav, MatSidenavContent } from '@angular/material/sidenav';
import { MatToolbar } from '@angular/material/toolbar';
import { MatNavList, MatDivider } from '@angular/material/list';
import { NavMenuItemComponent } from '../nav-menu-item/nav-menu-item.component';
import { MatButton, MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import { ToolbarComponent } from '../../toolbar/toolbar/toolbar.component';
import { LoaderComponent } from '../../shared/components/loader/loader.component';
import { UserMenuComponent } from '../user-menu/user-menu.component';
import { ThemeService } from '../../shared/system/theme.service';
import { TranslatePipe } from '@ngx-translate/core';
import { version as appVersion } from '../../../../package.json';

@Component({
    selector: 'nbd-navigation',
    templateUrl: './navigation.component.html',
    styleUrls: ['./navigation.component.scss'],
    imports: [MatSidenavContainer, MatSidenav, MatToolbar, MatNavList, NavMenuItemComponent, MatDivider, MatButton, RouterLink, RouterLinkActive, MatSidenavContent, MatIconButton, MatIcon, MatTooltip, ToolbarComponent, ToolbarMenuHostDirective, UserMenuComponent, RouterOutlet, LoaderComponent, AsyncPipe, TranslatePipe]
})
export class NavigationComponent extends BaseRxjsComponent implements OnDestroy {
  hs = inject(HelperService);
  cs = inject(CoreService);
  gl = inject(GlobalLoaderService);
  auth = inject(AuthService);
  es = inject(EventsService);
  protected theme = inject(ThemeService);
  private location = inject(Location);
  private router = inject(Router);


  protected readonly environment = environment;
  // App version shown at the foot of the sidebar (R4) — single-sourced from package.json.
  protected readonly appVersion = appVersion;
  // Current year for the sidebar copyright line.
  protected readonly year = new Date().getFullYear();
  private toolbar$ = new ReplaySubject<ToolbarMenuHostDirective>(1);

  /** The scrolling region that wraps the router-outlet (NOT the window). */
  @ViewChild('mainContent') private mainContent?: ElementRef<HTMLElement>;

  constructor() {

    super();

    // Reset the content scroll to the top on every route change. The app scrolls an
    // inner `overflow-y-auto` container, not the document, so the router's
    // scrollPositionRestoration (which targets the viewport) can't do this.
    this.sub = this.router.events.pipe(
      filter((e): e is NavigationEnd => e instanceof NavigationEnd),
      tap(() => this.mainContent?.nativeElement.scrollTo({top: 0, left: 0})),
    ).subscribe();

    this.sub = this.hs.toolbarComponent$.pipe(
      combineLatestWith(this.toolbar$.pipe(
        distinctUntilChanged()
      )),
      tap(([component, toolbar]) => {
        const viewContainerRef = toolbar.viewContainerRef;
        viewContainerRef.clear();
        if (component) {
          const componentRef = viewContainerRef.createComponent<NonNullable<typeof component.component>>(component.componentType);
          componentRef.instance.data = component.data;
        }
      })
    ).subscribe();
  }

  @ViewChild(ToolbarMenuHostDirective) set toolbarMenuHost(value: ToolbarMenuHostDirective) {
    if (value) {
      this.toolbar$.next(value);
    }
  }

  // toggleMenu() {
  //   this.collapseMenu = !this.collapseMenu;
  // }

  back(): void {
    this.cs.navHistory.pop();
    if (this.cs.navHistory.size() > 0) {
      this.location.back();
    } else if (this.hs.backBtnFallback) {
      this.router.navigate(this.hs.backBtnFallback);
      this.hs.backBtnFallback = undefined;
    } else {
      this.router.navigateByUrl('/');
    }
  }
}
